/* SEVINSE · Hoş geldin pop-up'ı — davranış katmanı (Sprint 04).
   Harici bağımlılık ve takip betiği yok. Yerleşik <dialog>.showModal()
   odağı tutar ve Escape'i işler; Tab döngüsü ayrıca sarılır.

   Depolama anahtarları:
     localStorage  sev_welcome_subscribed       abone oldu → bir daha gösterme
     localStorage  sev_welcome_dismissed_until  kapatınca N gün gösterme (ayar > 0)
     sessionStorage sev_welcome_dismissed        kapatınca bu oturumda gösterme (ayar = 0)
     sessionStorage sev_welcome_submitting       gönderim bu pop-up'tan yapıldı (sayfa yenilenir) */
(() => {
  const KEYS = {
    subscribed: 'sev_welcome_subscribed',
    dismissedUntil: 'sev_welcome_dismissed_until',
    dismissedSession: 'sev_welcome_dismissed',
    submitting: 'sev_welcome_submitting'
  };

  const read = (storage, key) => {
    try { return window[storage].getItem(key); } catch (e) { return null; }
  };
  const write = (storage, key, value) => {
    try { window[storage].setItem(key, value); } catch (e) { /* özel mod / kapalı depolama */ }
  };
  const remove = (storage, key) => {
    try { window[storage].removeItem(key); } catch (e) { /* yoksay */ }
  };

  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const isVisible = (el) => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

  const fallbackCopy = (text, host) => {
    try {
      const area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      host.appendChild(area);
      area.select();
      const ok = document.execCommand('copy');
      area.remove();
      return ok;
    } catch (e) {
      return false;
    }
  };

  const cleanUrl = () => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.hash = '';
      window.history.replaceState(null, '', url.toString());
    } catch (e) { /* yoksay */ }
  };

  const setup = (dialog) => {
    if (!dialog || dialog.dataset.sevInit === '1' || typeof dialog.showModal !== 'function') return;
    dialog.dataset.sevInit = '1';

    const form = dialog.querySelector('form');
    const stateEl = dialog.querySelector('[data-sev-welcome-state]');
    const state = stateEl ? stateEl.dataset.sevWelcomeState : 'form';
    const delay = Math.max(0, parseInt(dialog.dataset.delay, 10) || 0);
    const dismissDays = Math.max(0, parseInt(dialog.dataset.dismissDays, 10) || 0);
    const designMode = dialog.dataset.designMode === 'true';
    const emailInput = dialog.querySelector('input[type="email"]');

    const params = new URLSearchParams(window.location.search);
    const posted = params.get('customer_posted') === 'true';
    const ownSubmission =
      read('sessionStorage', KEYS.submitting) === '1' ||
      (!!form && window.location.hash === '#' + form.id);
    remove('sessionStorage', KEYS.submitting);

    let restoreFocus = null;
    let settled = true; // kapanış temizliği yapıldı mı (idempotent)

    const onKeydown = (event) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        // Yerleşik dialog Escape'i zaten işler; açık ele alma tarayıcı farklarını kapatır.
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = Array.from(dialog.querySelectorAll(FOCUSABLE)).filter(isVisible);
      if (!items.length) {
        event.preventDefault();
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || active === dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || active === dialog && items.length === 1)) {
        event.preventDefault();
        first.focus();
      }
    };

    const open = (focusTarget) => {
      if (dialog.open) return;
      restoreFocus = document.activeElement;
      settled = false;
      dialog.showModal();
      document.documentElement.classList.add('sev-welcome-open');
      dialog.addEventListener('keydown', onKeydown);
      (focusTarget || dialog).focus({ preventScroll: true });
    };

    const rememberDismissal = () => {
      if (designMode || state === 'success') return;
      if (dismissDays > 0) {
        write('localStorage', KEYS.dismissedUntil, String(Date.now() + dismissDays * 864e5));
      } else {
        write('sessionStorage', KEYS.dismissedSession, '1');
      }
    };

    // Kapanış temizliği: her kapatma yolundan (buton, Escape, arka plan, yerleşik
    // cancel/close) çağrılır; `close` olayına tek başına güvenilmez.
    const afterClose = () => {
      if (settled) return;
      settled = true;
      dialog.removeEventListener('keydown', onKeydown);
      document.documentElement.classList.remove('sev-welcome-open');
      rememberDismissal();
      if (restoreFocus && typeof restoreFocus.focus === 'function') {
        restoreFocus.focus({ preventScroll: true });
      }
    };

    const close = () => {
      if (dialog.open) dialog.close();
      afterClose();
    };

    // Sayfa yenilenmesiyle gelen durumlar (başarı/hata) yüklenme bittikten sonra açılır:
    // tarayıcının URL hash'ine (#SevinseWelcomeForm) odaklanma adımı, erken verilen
    // odağı sıfırlıyordu.
    const openAfterLoad = (focusTarget) => {
      const run = () => window.setTimeout(() => open(focusTarget), 0);
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    };

    dialog.addEventListener('close', afterClose);
    dialog.addEventListener('cancel', (event) => {
      // Yerleşik Escape yolu: temizliği kendimiz yapmak için varsayılanı durdur.
      event.preventDefault();
      close();
    });

    dialog.querySelectorAll('[data-sev-welcome-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    // Karartılmış alana tıklama: hedef dialog'un kendisidir (iç sarmalayıcı değil).
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    if (form) {
      form.addEventListener('submit', () => write('sessionStorage', KEYS.submitting, '1'));
    }

    const copyButton = dialog.querySelector('[data-sev-welcome-copy]');
    const status = dialog.querySelector('[data-sev-welcome-status]');
    if (copyButton) {
      const label = copyButton.textContent;
      copyButton.addEventListener('click', async () => {
        const code = copyButton.dataset.code || '';
        let ok = false;
        try {
          await navigator.clipboard.writeText(code);
          ok = true;
        } catch (e) {
          ok = fallbackCopy(code, dialog);
        }
        if (status) {
          status.textContent = ok
            ? 'Kod kopyalandı.'
            : 'Kopyalanamadı. Kodu seçip elle kopyalayabilirsin.';
        }
        if (ok) {
          copyButton.textContent = 'Kopyalandı';
          window.setTimeout(() => { copyButton.textContent = label; }, 2500);
        }
      });
    }

    // Tema düzenleyicisi: kendiliğinden açılmaz; bölüm seçilince önizlenir.
    if (designMode) {
      const sectionId = dialog.dataset.sectionId;
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail && event.detail.sectionId === sectionId) open();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail && event.detail.sectionId === sectionId && dialog.open) close();
      });
      return;
    }

    if (state === 'success') {
      // Bu sayfadaki bir customer formu başarıyla gönderildi (pop-up ya da footer).
      write('localStorage', KEYS.subscribed, '1');
      if (ownSubmission) {
        openAfterLoad();
        cleanUrl();
      }
      return;
    }

    if (state === 'error') {
      if (ownSubmission) openAfterLoad(emailInput);
      return;
    }

    if (posted) {
      write('localStorage', KEYS.subscribed, '1');
      return;
    }

    if (read('localStorage', KEYS.subscribed) === '1') return;

    const until = parseInt(read('localStorage', KEYS.dismissedUntil), 10);
    if (until && Date.now() < until) return;
    if (read('sessionStorage', KEYS.dismissedSession) === '1') return;

    window.setTimeout(() => open(), delay);
  };

  const init = () => document.querySelectorAll('[data-sev-welcome]').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Düzenleyici bölümü yeniden bastığında (ayar değişikliği) yeni öğeyi bağla.
  document.addEventListener('shopify:section:load', (event) => {
    const dialog = event.target && event.target.querySelector
      ? event.target.querySelector('[data-sev-welcome]')
      : null;
    if (dialog) setup(dialog);
  });
})();